module.exports = __webpack_public_path__ + "media/assisted-journaling-720.a7bb7efb.mp4";